const QUESTIONS = [
  {
    id: 'mañana',
    num: '01',
    title: '¿Cómo se siente tu piel al despertar?',
    sub: 'Sin productos aplicados, en su estado natural',
    type: 'single',
    grid: false,
    options: [
      { e:'✨', t:'Fresca y equilibrada', d:'Ni grasa ni reseca', v:'normal' },
      { e:'💧', t:'Tirante y reseca', d:'Pide hidratación urgente', v:'seca' },
      { e:'✨', t:'Brillosa o grasa', d:'Especialmente en frente y nariz', v:'grasa' },
      { e:'🌓', t:'Grasa en el centro, seca en mejillas', d:'Zona T brillosa, resto normal', v:'mixta' },
      { e:'🌸', t:'Irritada o sensible', d:'Rojez o ardor sin razón aparente', v:'sensible' },
    ]
  },
  {
    id: 'poros',
    num: '02',
    title: '¿Cómo describirías tus poros?',
    sub: 'Obsérvate de cerca en un espejo con luz natural',
    type: 'single',
    grid: true,
    options: [
      { e:'🔍', t:'Casi invisibles', d:'Poros muy pequeños', v:'normal' },
      { e:'🫧', t:'Pequeños y finos', d:'Piel de textura suave', v:'seca' },
      { e:'⭕', t:'Grandes y visibles', d:'Especialmente en nariz', v:'grasa' },
      { e:'🌓', t:'Grandes en la T, finos en mejillas', d:'', v:'mixta' },
      { e:'🌹', t:'Rojez o capilares visibles', d:'Piel reactiva', v:'sensible' },
    ]
  },
  {
    id: 'mediodia',
    num: '03',
    title: 'A mediodía, sin retocarte, tu piel se ve:',
    sub: 'Un día típico, clima normal',
    type: 'single',
    grid: false,
    options: [
      { e:'🙂', t:'Igual que en la mañana', d:'Sin cambios notables', v:'normal' },
      { e:'🫨', t:'Más reseca o jalada', d:'Maquillaje se ve cuarteado', v:'seca' },
      { e:'💦', t:'Brillosa en toda la cara', d:'Necesito papel matificante', v:'grasa' },
      { e:'📍', t:'Brillosa solo en zona T', d:'Mejillas siguen bien', v:'mixta' },
      { e:'🔴', t:'Más irritada o reactiva', d:'Rojez o ardor', v:'sensible' },
    ]
  },
  {
    id: 'preocupacion',
    num: '04',
    title: '¿Cuál es tu mayor preocupación de piel?',
    sub: 'Puedes identificarte con más de uno — elige el principal',
    type: 'single',
    grid: true,
    options: [
      { e:'🌙', t:'Resequedad y opacidad', d:'Piel sin vida', v:'seca' },
      { e:'🔴', t:'Acné y puntos negros', d:'Brotes frecuentes', v:'grasa' },
      { e:'🌟', t:'Manchas o tono desigual', d:'Hiperpigmentación', v:'mixta' },
      { e:'🌸', t:'Rojez y reacciones', d:'Sensibilidad alta', v:'sensible' },
      { e:'⏳', t:'Arrugas y firmeza', d:'Signos de envejecimiento', v:'normal_madura' },
      { e:'✅', t:'Ninguna en especial', d:'Piel bastante equilibrada', v:'normal' },
    ]
  },
  {
    id: 'reaccion',
    num: '05',
    title: '¿Cómo reacciona tu piel a nuevos productos?',
    sub: 'Cuando pruebas una crema o jabón nuevo',
    type: 'single',
    grid: false,
    options: [
      { e:'😊', t:'Sin problema, se adapta fácil', d:'Pocas reacciones adversas', v:'normal' },
      { e:'🤍', t:'Absorbe todo rápidamente', d:'Siempre pide más', v:'seca' },
      { e:'💫', t:'A veces se irrita o sale acné', d:'Hay que tener cuidado', v:'grasa' },
      { e:'⚠️', t:'Reacciona con rojez o ardor', d:'Soy muy selectiva con productos', v:'sensible' },
      { e:'🔄', t:'Depende del área de la cara', d:'Zona T reacciona diferente', v:'mixta' },
    ]
  },
  {
    id: 'clima',
    num: '06',
    title: '¿Cómo afecta el clima a tu piel?',
    sub: 'Piensa en cuando cambia el clima o viajas',
    type: 'single',
    grid: true,
    options: [
      { e:'☀️', t:'El calor me pone muy grasa', d:'En verano sufro más', v:'grosa' },
      { e:'❄️', t:'El frío la reseca mucho', d:'Invierno es difícil', v:'seca' },
      { e:'🌈', t:'Se adapta bastante bien', d:'No cambia mucho', v:'normal' },
      { e:'🌬️', t:'Cualquier cambio la irrita', d:'Muy reactiva al ambiente', v:'sensible' },
      { e:'🔄', t:'Grasa en verano, seca en invierno', d:'Cambia con las estaciones', v:'mixta' },
    ]
  },
];

// ══════════════════════════════════
// SKIN PROFILES
// ══════════════════════════════════
const PROFILES = {
  normal: {
    emoji: '✨',
    badge: 'Piel Normal',
    badgeColor: '#2E7D5E',
    title: 'Tienes Piel Normal',
    desc: '¡Qué afortunada! Tu piel está naturalmente equilibrada — produce la cantidad justa de sebo, tiene poros pequeños y rara vez se irrita. El objetivo es mantener ese equilibrio y prevenir el envejecimiento prematuro.',
    traits: [
      { icon:'💧', title:'Hidratación equilibrada', desc:'No muy seca, no muy grasa' },
      { icon:'🔬', title:'Poros pequeños', desc:'Textura suave y uniforme' },
      { icon:'✨', title:'Tono uniforme', desc:'Pocas manchas o imperfecciones' },
      { icon:'💪', title:'Tolerante a productos', desc:'Se adapta bien a cambios' },
    ],
    routine: [
      { label:'Mañana', step:'Limpia con jabón suave de aceite de oliva. No necesitas limpieza agresiva.' },
      { label:'Hidratación', step:'Aplica una crema ligera o aceite de jojoba. Hidratación sin sobrecargar.' },
      { label:'Noche', step:'Desmaquíllate bien y aplica aceite de rosa mosqueta o argán. Aprovecha la noche.' },
      { label:'Semanal', step:'Exfoliación suave 1-2 veces por semana para mantener el brillo natural.' },
    ],
    products: [
      { tag:'Jabón', name:'Jabón de Arroz', reason:'Exfolia muy ligero con harina de arroz, para piel normal y mixta', url:'/products/jabon-de-arroz' },
      { tag:'Hidratante', name:'Jabón de Índigo y Verbena', reason:'Limpia sin resecar y mantiene el equilibrio', url:'/products/jabon-de-indigo-y-verbena' },
      { tag:'Energía', name:'Jabón de Naranja', reason:'Aroma cítrico que despierta, ideal para la mañana', url:'/products/jabon-de-naranja' },
      { tag:'Especial', name:'Jabón de Espirulina y Hierbabuena', reason:'Refrescante, con espirulina y hierbabuena', url:'/products/jabon-de-espirulina-y-hierbabuena' },
    ],
    waMsg: 'Mi tipo de piel es: ✨ Normal — equilibrada y saludable. Recomiéndame productos de Mar Amoli para mantenerla así.',
  },
  seca: {
    emoji: '🌿',
    badge: 'Piel Seca',
    badgeColor: '#C8793A',
    title: 'Tienes Piel Seca',
    desc: 'Tu piel produce menos sebo del ideal y necesita hidratación constante. La buena noticia: con los productos correctos puede verse radiante y suave. Los jabones artesanales de Mar Amoli están formulados para limpiar sin resecar.',
    traits: [
      { icon:'💨', title:'Sensación de tensión', desc:'Especialmente después de lavar' },
      { icon:'🌸', title:'Descamación ocasional', desc:'En mejillas y alrededor de la nariz' },
      { icon:'🔬', title:'Poros finos', desc:'Casi invisibles pero piel sin brillo' },
      { icon:'⚡', title:'Reacciona a ingredientes fuertes', desc:'Prefiere fórmulas suaves' },
    ],
    routine: [
      { label:'Mañana', step:'Limpia con el Jabón de Avena y Benjuí. Hidrata y exfolia suavemente sin resecar.' },
      { label:'Hidratación', step:'Aplica el Bálsamo Multiusos de Lavanda en zonas muy secas. Hidratación intensa.' },
      { label:'Noche', step:'Usa el Jabón de Aloe Vera y Menta. El aloe hidrata profundo mientras duermes.' },
      { label:'Semanal', step:'Exfolia muy suavemente 1 vez. El Jabón de Avena suaviza sin irritar.' },
    ],
    products: [
      { tag:'Limpieza', name:'Jabón de Avena y Benjuí', reason:'Hidrata y calma, limpieza sin tensión', url:'/products/jabon-de-avena-y-benjui' },
      { tag:'Hidratante', name:'Jabón de Aloe Vera y Menta', reason:'Aloe hidrata profundo, formulado para pieles secas', url:'/products/jabon-de-aloe-vera-y-menta' },
      { tag:'Nutrición', name:'Jabón Natural', reason:'Ultra-suave, ingredientes mínimos para pieles delicadas', url:'/products/jabon-natural' },
      { tag:'Bálsamo', name:'Bálsamo Multiusos de Lavanda', reason:'Hidratación intensa para zonas muy resecas', url:'/products/balsa-mo-multiusos-de-lavanda' },
    ],
    waMsg: 'Mi tipo de piel es: 🌿 Seca — necesita hidratación intensa. Recomiéndame productos de Mar Amoli para nutrirla.',
  },
  grasa: {
    emoji: '💫',
    badge: 'Piel Grasa',
    badgeColor: '#4A9B8E',
    title: 'Tienes Piel Grasa',
    desc: 'Tu piel produce más sebo del necesario, lo que puede causar brillos y acné. Pero tiene una ventaja: envejece más lento. La clave es equilibrar sin sobre-limpiar. Los jabones de arcilla y carbón de Mar Amoli son perfectos para ti.',
    traits: [
      { icon:'💦', title:'Brillo constante', desc:'Especialmente en zona T' },
      { icon:'⭕', title:'Poros dilatados', desc:'Visibles en nariz y frente' },
      { icon:'🔴', title:'Tendencia al acné', desc:'Puntos negros o brotes frecuentes' },
      { icon:'⏳', title:'Envejece más lento', desc:'El sebo natural actúa como protector' },
    ],
    routine: [
      { label:'Mañana', step:'Jabón de Carbón Activado o Barro Verde con Tea Tree. Limpieza profunda sin resecar.' },
      { label:'Hidratación', step:'Usa el Jabón de Espirulina: equilibra sin obstruir poros. Hidratación ligera.' },
      { label:'Noche', step:'Limpieza doble: primero disuelve el exceso con Carbón y Pachulí, luego enjuaga bien.' },
      { label:'Semanal', step:'Exfolia con Jabón de Café, Cacao y Canela. Desincrustra poros profundamente.' },
    ],
    products: [
      { tag:'Piel Grasa', name:'Jabón de Carbón Activado', reason:'Absorbe el exceso de grasa del día', url:'/products/jabon-de-carbon-activado' },
      { tag:'Purificante', name:'Jabón de Barro Verde y Tea Tree', reason:'Barro verde y tea tree, limpieza profunda de poros', url:'/products/jabon-de-barro-verde-y-tea-tree' },
      { tag:'Exfoliante', name:'Jabón de Café, Cacao y Canela', reason:'Exfolia y controla brillo naturalmente', url:'/products/jabon-de-cafe-cacao-y-canela' },
      { tag:'Especial', name:'Jabón de Carbón Activado y Pachulí', reason:'Relajante y purificante, para piel grasa o mixta', url:'/products/jabon-de-carbon-activado-y-pachuli' },
    ],
    waMsg: 'Mi tipo de piel es: 💫 Grasa — con tendencia al acné. Recomiéndame productos de Mar Amoli para equilibrarla.',
  },
  mixta: {
    emoji: '🌓',
    badge: 'Piel Mixta',
    badgeColor: '#0D1B2A',
    title: 'Tienes Piel Mixta',
    desc: 'El tipo de piel más común. Tu zona T (frente, nariz, barbilla) tiende a ser grasa mientras las mejillas son normales o secas. Los jabones de Mar Amoli están formulados para equilibrar ambas zonas sin extremos.',
    traits: [
      { icon:'🌓', title:'Zona T grasa', desc:'Brillo y poros en frente y nariz' },
      { icon:'🌸', title:'Mejillas normales o secas', desc:'Sin brillo pero quizá algo resecas' },
      { icon:'🔄', title:'Cambia con el clima', desc:'Más grasa en verano, más seca en invierno' },
      { icon:'⚖️', title:'Necesita equilibrio', desc:'Ni muy hidratante ni muy astringente' },
    ],
    routine: [
      { label:'Mañana', step:'Jabón de Avena y Benjuí o Índigo y Verbena. Equilibrado para toda la cara.' },
      { label:'Hidratación', step:'Zona T: nada o muy poco. Mejillas: Bálsamo de Lavanda en puntos secos.' },
      { label:'Noche', step:'Jabón de Cúrcuma y Lemongrass: limpia la zona T sin resecar las mejillas.' },
      { label:'Semanal', step:'Exfolia zona T con Jabón de Tepezcohuite. Suaviza mejillas con Jabón de Avena.' },
    ],
    products: [
      { tag:'Equilibrante', name:'Jabón de Índigo y Verbena', reason:'Limpia la zona T e hidrata las mejillas a la vez', url:'/products/jabon-de-indigo-y-verbena' },
      { tag:'Equilibrio', name:'Jabón de Cúrcuma y Lemongrass', reason:'Controla el brillo de la zona T', url:'/products/jabon-de-curcuma-y-lemongrass' },
      { tag:'Exfoliante', name:'Jabón de Tepezcohuite y Romero', reason:'Desincrusta zona T sin irritar mejillas', url:'/products/jabon-de-tepezcohuite-y-romero' },
      { tag:'Suave', name:'Jabón de Avena y Benjuí', reason:'Para días que la piel pide calma', url:'/products/jabon-de-avena-y-benjui' },
    ],
    waMsg: 'Mi tipo de piel es: 🌓 Mixta — zona T grasa y mejillas normales. Recomiéndame productos de Mar Amoli para equilibrarla.',
  },
  sensible: {
    emoji: '🌸',
    badge: 'Piel Sensible',
    badgeColor: '#C84A4A',
    title: 'Tienes Piel Sensible',
    desc: 'Tu piel reacciona fácilmente a ingredientes, cambios de temperatura o estrés. La clave es la simplicidad. Los jabones artesanales de Mar Amoli están hechos sin colorantes artificiales ni fragancias sintéticas — perfectos para ti.',
    traits: [
      { icon:'🌹', title:'Rojez frecuente', desc:'Se irrita con facilidad' },
      { icon:'🌡️', title:'Reactiva a cambios', desc:'Clima, agua, productos nuevos' },
      { icon:'⚠️', title:'Sensible a fragancias', desc:'Prefiere aceites esenciales suaves' },
      { icon:'💆', title:'Necesita simplicidad', desc:'Menos ingredientes = menos reacciones' },
    ],
    routine: [
      { label:'Mañana', step:'Jabón Natural o de Avena: formulados sin ingredientes agresivos, ultra-suaves.' },
      { label:'Hidratación', step:'Bálsamo Multiusos Natural: ingredientes mínimos, máxima calma para piel reactiva.' },
      { label:'Noche', step:'Jabón de Barro Rosa e Incienso: calma rojeces y repara la barrera cutánea.' },
      { label:'Semanal', step:'Sin exfoliación química. Jabón de Avena como exfoliante suavísimo, solo 1 vez.' },
    ],
    products: [
      { tag:'Esencial', name:'Jabón Natural', reason:'Formulado para pieles sensibles y secas, mínimos ingredientes', url:'/products/jabon-natural' },
      { tag:'Suave', name:'Jabón de Avena', reason:'Avena coloidal, suave para piel sensible', url:'/products/jabon-de-avena' },
      { tag:'Reparador', name:'Jabón de Barro Rosa e Incienso', reason:'Arcilla rosa e incienso, para piel que se irrita fácil', url:'/products/jabon-de-barro-rosa-e-incienso' },
      { tag:'Bálsamo', name:'Bálsamo Multiusos Natural', reason:'Sin fragancia añadida, máxima pureza para pieles reactivas', url:'/products/ba-lsamo-multiusos-natural' },
    ],
    waMsg: 'Mi tipo de piel es: 🌸 Sensible — reactiva e irritable. Recomiéndame productos de Mar Amoli sin ingredientes agresivos.',
  },
};

// ══════════════════════════════════
// STATE
// ══════════════════════════════════
let currentQ = 0;
let answers = {};
let skinResult = null;

// ══════════════════════════════════
// SCORING
// ══════════════════════════════════
function calcResult() {
  const scores = { normal:0, seca:0, grasa:0, mixta:0, sensible:0 };
  Object.values(answers).forEach(v => {
    if(v === 'grosa') v = 'grasa'; // typo fix
    if(v === 'normal_madura') v = 'normal';
    if(scores[v] !== undefined) scores[v]++;
  });
  return Object.entries(scores).sort((a,b) => b[1]-a[1])[0][0];
}

// ══════════════════════════════════
// RENDER
// ══════════════════════════════════
function renderProgress() {
  const total = QUESTIONS.length;
  const pct = ((currentQ + 1) / total) * 100;
  document.getElementById('progressFrac').textContent = `${Math.min(currentQ+1, total)} / ${total}`;
  document.getElementById('progressFill').style.width = pct + '%';

  let dots = '';
  for(let i = 0; i < total; i++) {
    const cls = i < currentQ ? 'done' : (i === currentQ ? 'active' : '');
    dots += `<div class="sdot ${cls}"></div>`;
  }
  document.getElementById('stepDots').innerHTML = dots;
}

function renderQuestion() {
  const q = QUESTIONS[currentQ];
  renderProgress();

  const optHtml = q.options.map((o, i) => `
    <div class="opt ${answers[q.id] === o.v ? 'selected' : ''}" onclick="selectOption('${q.id}','${o.v}',this)">
      <span class="opt-emoji">${o.e}</span>
      <div class="opt-text">
        <div class="opt-title">${o.t}</div>
        ${o.d ? `<div class="opt-desc">${o.d}</div>` : ''}
      </div>
      <div class="opt-check">${answers[q.id] === o.v ? '✓' : ''}</div>
    </div>
  `).join('');

  const html = `
    <div class="q-card">
      <div class="q-num">Pregunta ${q.num}</div>
      <div class="q-title">${q.title}</div>
      <div class="q-sub">${q.sub}</div>
      <div class="options ${q.grid ? 'grid2' : ''}">${optHtml}</div>
      <div class="q-nav">
        ${currentQ > 0 ? `<button class="btn-back" onclick="prevQ()">← Anterior</button>` : ''}
        <button class="btn-next ${answers[q.id] ? 'pulse' : ''}" id="btnNext" onclick="nextQ()" ${!answers[q.id] ? 'disabled' : ''}>
          ${currentQ < QUESTIONS.length - 1 ? 'Siguiente →' : 'Ver mi resultado →'}
        </button>
      </div>
    </div>
  `;
  document.getElementById('quizArea').innerHTML = html;
}

function selectOption(qId, val, el) {
  answers[qId] = val;
  document.querySelectorAll('.opt').forEach(o => {
    o.classList.remove('selected');
    o.querySelector('.opt-check').textContent = '';
  });
  el.classList.add('selected');
  el.querySelector('.opt-check').textContent = '✓';
  document.getElementById('btnNext').disabled = false;
  document.getElementById('btnNext').classList.add('pulse');

  // Auto-advance after short delay
  setTimeout(() => nextQ(), 600);
}

function nextQ() {
  const q = QUESTIONS[currentQ];
  if(!answers[q.id]) return;
  if(currentQ < QUESTIONS.length - 1) {
    currentQ++;
    document.getElementById('quizArea').innerHTML = '';
    setTimeout(() => renderQuestion(), 80);
  } else {
    finalizar();
  }
}

function prevQ() {
  if(currentQ > 0) {
    currentQ--;
    document.getElementById('quizArea').innerHTML = '';
    setTimeout(() => renderQuestion(), 80);
  }
}

// ══════════════════════════════════
// CIERRE DEL QUIZ
// ══════════════════════════════════
/**
 * El quiz mostraba el resultado sólo después de pedir nombre y correo.
 * Ahora el resultado es inmediato: nadie tiene que dejar sus datos para
 * ver su tipo de piel. El tipo se guarda en localStorage para poder
 * recuperarlo si vuelve a entrar.
 */
function finalizar() {
  skinResult = calcResult();
  document.getElementById('progressWrap').style.display = 'none';

  try {
    localStorage.setItem(
      'amoli_quiz_result',
      JSON.stringify({ skinResult: skinResult, date: new Date().toISOString() })
    );
  } catch (e) {
    // Modo privado o storage lleno — el resultado se muestra igual.
  }

  showResult('');
}

// ══════════════════════════════════
// RESULTS
// ══════════════════════════════════
function showResult(firstName) {
  const p = PROFILES[skinResult];
  document.getElementById('seoSection').style.display = 'block';

  const traitsHtml = p.traits.map(t => `
    <div class="trait">
      <span class="trait-icon">${t.icon}</span>
      <div class="trait-text"><strong>${t.title}</strong>${t.desc}</div>
    </div>
  `).join('');

  const routineHtml = p.routine.map((r, i) => `
    <div class="rstep">
      <div class="rstep-num">${i+1}</div>
      <div class="rstep-content">
        <div class="rstep-label">${r.label}</div>
        <div class="rstep-text">${r.step}</div>
      </div>
    </div>
  `).join('');

  const productsHtml = p.products.map(pr => `
    <a class="prod-card" href="${pr.url}">
      <div class="prod-tag">${pr.tag}</div>
      <div class="prod-name">${pr.name}</div>
      <div class="prod-reason">${pr.reason}</div>
      <span class="prod-cta">Ver producto →</span>
    </a>
  `).join('');

  const waText = encodeURIComponent(p.waMsg + '\namoli.mx/pages/quiz-tipo-de-piel');

  const html = `
    <div class="result-card">
      <div class="result-hero">
        <span class="skin-emoji">${p.emoji}</span>
        <div class="result-badge" style="background:${p.badgeColor}20;color:${p.badgeColor}">${p.badge}</div>
        <div class="result-title">${firstName ? `${firstName}, t` : 'T'}ienes ${p.badge}</div>
        <p class="result-desc">${p.desc}</p>
      </div>

      <div class="result-section">
        <div class="rs-title">Características de tu piel</div>
        <div class="traits">${traitsHtml}</div>
      </div>

      <div class="result-section">
        <div class="rs-title">Tu rutina personalizada</div>
        <div class="routine-steps">${routineHtml}</div>
      </div>

      <div class="result-section">
        <div class="rs-title">Productos ideales para ti</div>
        <div class="products-grid">${productsHtml}</div>
      </div>

      <div class="result-section">
        <div class="rs-title">Comparte tu resultado</div>
        <div class="share-row">
          <button class="btn-share btn-wa" onclick="window.open('https://wa.me/?text=${waText}','_blank')">💬 WhatsApp</button>
          <button class="btn-share btn-copy" onclick="copyResult()">📋 Copiar</button>
          <button class="btn-restart" onclick="restartQuiz()">↺ Repetir quiz</button>
        </div>
      </div>
    </div>
  `;

  document.getElementById('quizArea').innerHTML = html;
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function copyResult() {
  const p = PROFILES[skinResult];
  navigator.clipboard.writeText(`Mi tipo de piel es: ${p.badge}\n${p.desc}\n\nDescubre el tuyo en: amoli.mx/pages/quiz-tipo-de-piel`)
    .then(() => showToast('✅ ¡Copiado!'))
    .catch(() => showToast('Copia el link manualmente'));
}

function restartQuiz() {
  currentQ = 0; answers = {}; skinResult = null;
  document.getElementById('progressWrap').style.display = 'block';
  document.getElementById('seoSection').style.display = 'none';
  renderQuestion();
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

// ══════════════════════════════════
// TOAST
// ══════════════════════════════════
function showToast(msg) {
  const t = document.getElementById('toast');
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2800);
}

// ══════════════════════════════════
// INIT
// ══════════════════════════════════
renderQuestion();